import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  Building2,
  CalendarRange,
  ChartColumn,
  LayoutDashboard,
  LogOut,
  LUCIDE_ICONS,
  LucideIconProvider,
  Menu,
  Moon,
  Search,
  Sun,
  Users
} from 'lucide-angular';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideEchartsCore({ echarts }),
    {
      provide: LUCIDE_ICONS,
      useValue: new LucideIconProvider({
        Building2,
        CalendarRange,
        ChartColumn,
        LayoutDashboard,
        LogOut,
        Menu,
        Moon,
        Search,
        Sun,
        Users
      })
    }
  ]
};
